import beTwMerge from '@/utils/beTwMerge';

export default function HeaderNav({
  activePageNames,
  activePage,
  setInfo,
  info,
  dateSelected,
  timeSelected,
}: {
  activePageNames: { [key: number]: string };
  activePage: number;
  setInfo: (key: string, value: any) => void;
  info: any;
  dateSelected: string;
  timeSelected: string;
}) {
  const progressBarStyleWidth = {
    1: 'before:tw-hidden',
    2: 'before:tw-w-1/3',
    3: 'before:tw-w-2/3',
    4: 'before:tw-w-full',
  };

  function onClickItem(page: number) {
    (window as any).dataLayer.push({
      event: 'appointment_form',
      showroom_page_section: activePageNames[activePage],
      showroom_action: `progress bar click|${activePageNames[page]}`,
      showroom_location: info.selectedShowroomStore.modalName,
      general_event_details: 'Undefined',
    });

    setInfo('activePage', page);
  }

  return (
    <div className="tw-relative tw-justify-between tw-mt-4 tw-mx-auto tw-w-3/4 lg:tw-w-[640px] tw-flex lg:tw-mt-[15px]">
      <div
        className={beTwMerge(
          "tw-h-[2px] tw-top-2 tw-w-full tw-bg-[#B4CFCF] tw-absolute before:tw-content-[''] before:tw-h-full before:tw-bg-color-light-green-cta before:tw-absolute",
          progressBarStyleWidth[activePage]
        )}
      />
      <div className="tw-col-span-1 tw-w-full tw-relative tw-h-10">
        <button
          type="button"
          aria-label="Go to location page"
          className={beTwMerge(
            'tw-appearance-none tw-w-full lg:tw-w-full tw-absolute tw-border-none tw-bg-transparent tw-flex tw-flex-col tw-items-center tw-gap-2 tw-px-0 tw-left-0 -tw-translate-x-1/2'
          )}
          onClick={() => {
            onClickItem(1);
          }}
        >
          <div
            className={beTwMerge(
              'tw-w-4 tw-h-4 tw-relative tw-border-solid tw-bg-white tw-border-color-light-green tw-border-[2px] tw-rounded-full tw-z-10',
              activePage === 1 && 'tw-bg-white',
              activePage > 1 && 'tw-bg-color-light-green'
            )}
          />
          <span className="!tw-text-be-dark-gray tw-font-[500] tw-text-be-3xs  lg:tw-text-be-2xs tw-text-align-center tw-tracking-wider">
            LOCATION
          </span>

          <span className="tw-font-[350] !tw-font-book tw-text-color-grey-700 tw-absolute tw-text-be-xs tw-text-align-center tw-w-full tw-top-[40px] tw-hidden lg:tw-block lg:tw-w-[240px]">
            {activePage > 1 || info.selectedShowroomStore.modalName ? info.selectedShowroomStore.modalName : null}
          </span>
        </button>
      </div>
      <div className="tw-col-span-1 tw-w-full tw-relative tw-h-10">
        <button
          type="button"
          aria-label="Go to service page"
          className="tw-appearance-none tw-w-full lg:tw-w-full tw-absolute tw-border-none tw-bg-transparent tw-flex tw-flex-col tw-items-center tw-gap-2 tw-px-0 tw-left-1/3 -tw-translate-x-1/2"
          onClick={() => {
            if (
              !!info.selectedShowroomStore.city ||
              (!info.selectedShowroomStore.city && info.selectedShowroomStore.modalName === 'Virtual Appointment')
            )
              onClickItem(2);
          }}
        >
          <div
            className={beTwMerge(
              'tw-w-4 tw-h-4 tw-border-[2px] tw-border-solid tw-bg-white tw-rounded-full tw-z-10',
              activePage < 2 && 'tw-bg-white tw-border-[#B4CFCF]',
              activePage === 2 && 'tw-bg-white tw-border-color-light-green',
              activePage > 2 && 'tw-bg-color-light-green tw-border-color-light-green'
            )}
          />
          <span className="!tw-text-be-dark-gray tw-font-[500] tw-text-be-3xs  lg:tw-text-be-2xs tw-text-align-center tw-tracking-wider">
            SERVICE
          </span>
          <span className="tw-font-[350] tw-text-color-grey-700 tw-absolute tw-text-be-xs tw-text-align-center tw-hidden !tw-font-book lg:tw-block tw-min-w-fit tw-w-[130px] tw-top-[40px]">
            {activePage > 2 || info.selectedServiceName ? info.selectedServiceName : null}
          </span>
        </button>
      </div>
      <div className="tw-col-span-1 tw-w-full tw-relative tw-h-10">
        <button
          type="button"
          aria-label="Go to times page"
          className="tw-appearance-none tw-w-full lg:tw-w-full tw-absolute tw-border-none tw-bg-transparent tw-flex tw-flex-col tw-items-center tw-gap-2 tw-px-0 tw-left-2/3 -tw-translate-x-1/2"
          onClick={() => {
            if (
              (!!info.selectedShowroomStore.city ||
                (!info.selectedShowroomStore.city && info.selectedShowroomStore.modalName === 'Virtual Appointment')) &&
              info.selectedServiceName
            )
              onClickItem(3);
          }}
        >
          <div
            className={beTwMerge(
              'tw-w-4 tw-h-4 tw-border-solid tw-border-[2px] tw-bg-white tw-rounded-full tw-z-10',
              activePage < 3 && 'tw-bg-white tw-border-[#B4CFCF]',
              activePage === 3 && 'tw-bg-white tw-border-color-light-green',
              activePage > 3 && 'tw-bg-color-light-green tw-border-color-light-green'
            )}
          />
          <span className="!tw-text-be-dark-gray tw-font-[500] tw-text-be-3xs  lg:tw-text-be-2xs tw-text-center tw-tracking-wider">
            DATE & TIME
          </span>
          <div className="tw-font-[350] !tw-font-book tw-text-color-grey-700 tw-absolute tw-text-be-xs tw-text-center tw-hidden lg:tw-block tw-top-[40px] lg:tw-w-[284px]">
            {activePage > 2 || (info.selectedDate && info.selectedTime) ? (
              <>
                <div className="tw-hidden">
                  <span>{info.selectedDate && info.selectedTime ? dateSelected : null}</span>
                  <br />
                  <span>{info.selectedDate && info.selectedTime ? timeSelected : null}</span>
                </div>
                <span className="tw-block">
                  {dateSelected}
                  {timeSelected && timeSelected !== 'null' ? ` | ${timeSelected}` : ''}
                </span>
              </>
            ) : null}
          </div>
        </button>
      </div>
      <div className="tw-col-span-1 tw-w-full tw-relative tw-h-10">
        <button
          type="button"
          aria-label="Go to confirm page"
          className="tw-appearance-none tw-w-full tw-absolute tw-border-none tw-bg-transparent tw-flex tw-flex-col tw-items-center tw-gap-2 tw-px-0 tw-right-0 tw-translate-x-1/2"
          onClick={() => {
            if (
              (!!info.selectedShowroomStore.city ||
                (!info.selectedShowroomStore.city && info.selectedShowroomStore.modalName === 'Virtual Appointment')) &&
              info.selectedServiceName &&
              info.selectedDate &&
              info.selectedTime
            )
              onClickItem(4);
          }}
        >
          <div
            className={beTwMerge(
              'tw-w-4 tw-h-4 tw-border-solid tw-bg-white tw-border-color-light-green tw-border-[2px] tw-rounded-full tw-z-10',
              activePage < 4 && 'tw-bg-white tw-border-[#B4CFCF]',
              activePage === 4 && 'tw-bg-white tw-border-color-light-green'
            )}
          />
          <span className="!tw-text-be-dark-gray tw-font-[500] tw-text-be-3xs  lg:tw-text-be-2xs tw-text-align-center tw-tracking-wider">
            CONFIRM
          </span>
        </button>
      </div>
    </div>
  );
}
